module.exports = __webpack_public_path__ + "img/title1.6db958e0.png";